/** API_SPEC.md §8 — credits & billing. Balances are a ledger the server owns; the UI only reads them. */
import { api } from './client';
import type { Billing, CheckoutRequest, CheckoutResponse, Credits, LedgerEntry, Paginated } from './types';

export const billingApi = {
  credits: () => api<Credits>('/v1/credits'),
  ledger: (page = 1, perPage = 8) => api<Paginated<LedgerEntry>>('/v1/credits/ledger', { query: { page, per_page: perPage } }),
  billing: () => api<Billing>('/v1/billing'),
  /** Stripe Checkout; 402 `plan_required` for packs on Free. */
  checkout: (body: CheckoutRequest, idempotencyKey: string) => api<CheckoutResponse>('/v1/billing/checkout', { method: 'POST', body, idempotencyKey }),
  /** Stripe Customer Portal: change term, cancel, update card. */
  portal: () => api<CheckoutResponse>('/v1/billing/portal', { method: 'POST' }),
};
